import TourActions from './constants';
import { IActionObject } from './types';

export function initializeTourWithParams(tour: object): IActionObject {
  return { type: TourActions.SET_TOUR_PARAMS, data: { tour } };
}

export default {
  initializeTourWithParams,
};
try {
    // @ts-ignore
    initializeTourWithParams.displayName = "initializeTourWithParams";
    // @ts-ignore
    initializeTourWithParams.__docgenInfo = { "description": "", "displayName": "initializeTourWithParams", "props": {} };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/store/tour/actions.ts#initializeTourWithParams"] = { docgenInfo: initializeTourWithParams.__docgenInfo, name: "initializeTourWithParams", path: "src/store/tour/actions.ts#initializeTourWithParams" };
}
catch (__react_docgen_typescript_loader_error) { }